import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=4995e9ac&lang=pug&"
import script from "./Perfis.vue?vue&type=script&lang=js&"
export * from "./Perfis.vue?vue&type=script&lang=js&"
import style0 from "./Perfis.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports